import { ref } from '@vue/composition-api'
import {
  mdiCheckOutline,
  mdiCloseOutline,
} from '@mdi/js'

export default function useStatusesList() {
  const statusesList = ref([
    {
      id: 0,
      text: 'Inactivo',
      color: '#BDBDBD',
      icon: mdiCloseOutline,
    }, {
      id: 1,
      text: 'Activo',
      color: '#4CAF50',
      icon: mdiCheckOutline,
    },
  ])

  const GetById = id => statusesList.value.find(item => item.id === id)

  return {
    statusesList,
    GetById,
  }
}
